export default __webpack_public_path__ + "static/media/img7.5986b57f.jpg";